import React from 'react';
import Header from '../components/header';
import About from '../components/about';
import Projects from '../components/projects';
import Skills from '../components/skills';
import Contact from '../components/contact';
import Footer from '../components/footer';
import '../styles/landing-page.css';

const LandingPage = (props) => {
  return (
    <div className="landing-page-container">
      <Header rootClassName="header-root-class-name"></Header>
      <div className="landing-page-container1">
        <About id="about" />
        <Projects id="projects" />
        <Skills id="skills" />
        <Contact id="contacts" />
        <Footer rootClassName="footer-root-class-name" />
      </div>
    </div>
  );
};

export default LandingPage;
